import React, { useCallback } from 'react';
import { withTranslation } from '../ChildrenContext.js';
import PropTypes from 'prop-types';
import Parser from 'html-react-parser';
import Header from './DataComponent__TableHeader';
import Loading from '../Loading';

const DataComponentTable = ({
    data,
    headerNames,
    multiLevelHeaderNames,
    columnData,
    loading,
    className,
    t
}) => {
    const staticNames = (t && t.dataTable) || {};

    const getKey = useCallback((data) => {
        if (React.isValidElement(data)) {
            return getKey(data.props.children);
        }
        return data;
    }, []);

    return (
        <div className="loading-wrapper">
            {loading && (Array.isArray(data) ? data.length : Object.keys(data || {}).length)
                ? <div className="loading-wrapper__item"><Loading /></div>
                : null
            }
            <div className="table-responsive">
                <table className={`table table-data ${className}`}>
                    <Header
                        headerNames={headerNames}
                        multiLevelHeaderNames={multiLevelHeaderNames}
                        columnData={columnData?.header}
                    />
                    <tbody>
                        {(Array.isArray(data) ? data : Object.values(data || {})).map((item, i) => {
                            let className = item.className;
                            delete item.className;
                            return (
                                <tr key={getKey(item.id || i)} className={className}>
                                    {Object.keys(item).map((key, j) => {
                                        const dataCell = columnData?.body?.[j] || {};
                                        let value;

                                        if (typeof item[key] === 'object') {
                                            value = item[key];
                                        } else if (typeof item[key] === 'string'){
                                            value = Parser(item[key]);
                                        }

                                        if(value === undefined) {
                                            return null;
                                        }

                                        return <td className={key} key={j} {...dataCell}>{value}</td>
                                    })}
                                </tr>
                            )
                        })}
                    </tbody>
                </table>
                {!data?.length
                    ? loading
                        ? <Loading center={true} />
                        : <div className="text-center table-notfound-sign">{staticNames.noData}</div>
                    : null
                }
            </div>
        </div>
    );
};

DataComponentTable.propTypes = {
    data: PropTypes.array,
    headerNames: PropTypes.array,
    multiLevelHeaderNames: PropTypes.array,
    columnData: PropTypes.shape({
        header: PropTypes.object,
        body: PropTypes.object
    }),
    loading: PropTypes.bool,
    className: PropTypes.string,
    t: PropTypes.object
};

DataComponentTable.defaultProps = {
    data: [],
    headerNames: [],
    multiLevelHeaderNames: [],
    columnData: {
        header: {},
        body: {}
    },
    loading: false,
    className: '',
    t: {}
};

export default withTranslation(DataComponentTable);
